/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var $sidebarmenu = $("html");
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === "lang") {
      var attributeValue = $(mutation.target).prop(mutation.attributeName);
      console.log("Onverifie l'attribut" + attributeValue.toLowerCase());
      if (attributeValue.toLowerCase() === 'fr') { 
        $('.Product__SlideshowNavImage > img').each(function(){
          if ($(this).attr('alt') == 'FR') {
            $(this).parent().show();
          } else if ($(this).attr('alt') == 'EN') {
            $(this).parent().hide();
          }
        });
        
        /*$('#smile-ui-container').show();*/
        $('#newsletter_fr').show();
        $('#newsletter_fr #klaviyo_ariaid_5').html('Veuillez renseigner ce champ.');
        $('#newsletter_en').hide();
        if (window.location.href.indexOf("le-quizz-erotique-en") > -1) {
      		window.location.href = '/pages/diagnostic-lubrifiant';
     	}
        
      } else {
        $('.Product__SlideshowNavImage > img').each(function(){
          if ($(this).attr('alt') == 'EN') {
            $(this).parent().show();
          } else if ($(this).attr('alt') == 'FR') {
            $(this).parent().hide();
          }
        });
        $('#newsletter_fr').hide();
        $('#newsletter_en').show();
        /*$('#smile-ui-container').hide();*/
        
        if (window.location.href.indexOf("diagnostic-lubrifiant") > -1) {
      		window.location.href = '/pages/le-quizz-erotique-en';
     	}
      }
    }
  });
});
observer.observe($sidebarmenu[0], {
  attributes: true
});

$( document ).ready(function() {
  	var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Windows Phone|webOS|Opera Mini|Silk/.test(navigator.userAgent) ? "m" : "d";
  	let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

    if (isMobile) {
      $(".sca-qv-button-wrap").remove();
    }
  
  	if (deviceType == 'm') {
      $(".Footer__Block--links > .Footer__Title").click( function () {
          $('#section-footer .Linklist').hide();
          $(this).next('.Linklist').show();
      });
  
  	  $(".sca-qv-button-wrap").remove();
    }
  
  	if ($("html").attr("lang").toLowerCase() === 'fr') {
    	$('.Product__SlideshowNavImage > img').each(function(){
          if ($(this).attr('alt') == 'FR') {
            $(this).parent().show();
          } else if ($(this).attr('alt') == 'EN') {
            $(this).parent().hide();
          }
        });
      	$('#newsletter_fr').show();
      	/*$('#smile-ui-container').show();*/
      	$('#newsletter_fr #klaviyo_ariaid_5').html('Veuillez renseigner ce champ.');
        $('#newsletter_en').hide();
    } else {
     	$('.Product__SlideshowNavImage > img').each(function(){
          if ($(this).attr('alt') == 'EN') {
            $(this).parent().show();
          } else if ($(this).attr('alt') == 'FR') {
            $(this).parent().hide();
          }
        });
      	$('#newsletter_fr').hide();
        $('#newsletter_en').show();
      	/*$('#smile-ui-container').hide();*/
    }
  
  $(document).on('change', 'html', function() {
    if ($("html").attr("lang").toLowerCase() === 'fr') { 
      $('.Product__SlideshowNavImage > img').each(function(){
          if ($(this).attr('alt') == 'FR') {
            $(this).parent().show();
          } else if ($(this).attr('alt') == 'EN') {
            $(this).parent().hide();
          }
        });
      	$('#newsletter_fr').show();
      	$('#newsletter_fr #klaviyo_ariaid_5').html('Veuillez renseigner ce champ.');
        $('#newsletter_en').hide();
      	/*$('#smile-ui-container').show();*/
      	/*if (window.location.href.indexOf("le-quizz-erotique-en") > -1) {
      	window.location.href = '/pages/le-quizz-erotique-fr';
     	}*/
    } else {
      $('.Product__SlideshowNavImage > img').each(function(){
          if ($(this).attr('alt') == 'EN') {
            $(this).parent().show();
          } else if ($(this).attr('alt') == 'FR') {
            $(this).parent().hide();
          }
        });
      	$('#newsletter_fr').hide();
        $('#newsletter_en').show();
      	/*$('#smile-ui-container').hide();*/
    }
  });
  
  $("body").on('DOMSubtreeModified', "#newsletter_fr", function() {
    if ( $("#newsletter_fr span[role='alert']").text() != 'Veuillez renseigner ce champ.') {
      if ($("html").attr("lang").toLowerCase() === 'fr') {
        $("#newsletter_fr span[role='alert']").html('Veuillez renseigner ce champ.');
      }
    }
  });
  
  // $("body").on('DOMSubtreeModified', "#smile-ui-container", function() {
      
  //   if ($("html").attr("lang").toLowerCase() === 'fr') {
  //       /*$('#smile-ui-container').show();*/
  //     } else {
  //       /*$('#smile-ui-container').hide();*/
  //     }
  // });


  if($('.template-collection.length') && $('.footer_reassurance_collection_overlay_deployer').length){
  	$('.footer_reassurance_collection_overlay_deployer').click(function(){
  		$('.footer_reassurance_collection_overlay_deployer').fadeOut(200);
  		$('.footer_reassurance_collection_content').addClass('footer_reassurance_content_init');
  		$('.footer_reassurance_not_init').removeClass("footer_reassurance_not_init");
  	});
  }

  $(document).on('click', '.StampedReview li.next a', function(){
    $(this).closest('.StampedReview').addClass('active');
  })

});
